import React, { useContext, useEffect, useState } from 'react';
import pt from 'prop-types';
import Icon from '../icon';
import Link from '../link';
import Text from '../text';
import { combine } from '../../../helpers/styles';
import * as styles from './styles.module.scss';
import { getCopy } from '../../../helpers/copy';
import { MicrocopyContext } from '../../../context/microcopy.context';
import { STATIC_ROUTES } from '../../../utils/constants';

const DetailNavigation = ({ navigationObject, type }) => {
  const microcopy = useContext(MicrocopyContext);
  const [storageDetails, setStorageDetails] = useState({});

  useEffect(() => {
    const payloadAsString = sessionStorage.getItem(`${type}Payload`);
    const count = sessionStorage.getItem(`${type}Count`);
    const queryParams = sessionStorage.getItem(`${type}QueryParams`);
    const backLinkType = sessionStorage.getItem(`returnToSearchPage`)
      ? 'search'
      : type;

    if (payloadAsString && count != null) {
      setStorageDetails({
        payload: JSON.parse(payloadAsString),
        count,
        queryParams,
        backLinkType,
      });
    }
  }, [type]);

  const setDetailNavigationPage = (page) => {
    const payloadAsString = sessionStorage?.getItem(`${type}Payload`);

    if (payloadAsString) {
      const payload = JSON.parse(payloadAsString);
      payload.page = page;
      sessionStorage.setItem(`${type}Payload`, JSON.stringify(payload));
    }
  };

  const getBackLink = () => {
    switch (storageDetails?.backLinkType) {
      case 'search':
        return {
          linkToPage: `/search?${storageDetails.queryParams}`,
          anchor: 'resultList',
        };
      case 'project':
        return {
          linkToPage: STATIC_ROUTES.PROJECT_FILTER_PAGE,
          queryParameter: storageDetails.queryParams,
        };
      case 'profile':
        return {
          linkToPage: STATIC_ROUTES.COMPANY_FILTER_PAGE,
          queryParameter: storageDetails.queryParams,
        };
      case 'sip':
        return {
          linkToPage: STATIC_ROUTES.SP_FILTER_PAGE,
          queryParameter: storageDetails.queryParams,
        };
      case 'student':
        return {
          linkToPage: STATIC_ROUTES.STUDENT_FILTER_PAGE,
          queryParameter: storageDetails.queryParams,
        };
      default:
        return {
          linkToPage: STATIC_ROUTES.PROJECT_FILTER_PAGE,
          queryParameter: storageDetails.queryParams,
        };
    }
  };

  return (
    <div
      className={combine(
        styles.detailNavigation,
        !navigationObject?.previous && !navigationObject?.next && styles.hidden
      )}
    >
      {navigationObject?.previous?.slug ? (
        <Link
          link={{ linkToPage: navigationObject.previous.slug }}
          onClick={() =>
            setDetailNavigationPage(navigationObject.previous.page, type)
          }
          useGatsbyLink={false}
          className={combine(styles.navigationLink, styles.previous)}
        >
          <Icon name="chevron-left" size={'2x'} />
          <Text className={combine(styles.spaced, styles.navigationText)}>
            {getCopy('detailPageNavigation.prev', microcopy)}
          </Text>
        </Link>
      ) : (
        <span></span>
      )}
      <Link link={getBackLink()} useGatsbyLink={false}>
        <Text className={combine(styles.spaced, styles.styled)}>{`${getCopy(
          'detailPageNavigation.back',
          microcopy
        )} (${storageDetails.count || 0})`}</Text>
      </Link>
      {navigationObject?.next?.slug ? (
        <Link
          link={{ linkToPage: navigationObject.next.slug }}
          onClick={() => setDetailNavigationPage(navigationObject.next.page)}
          useGatsbyLink={false}
          className={combine(styles.navigationLink, styles.next)}
        >
          <Text className={combine(styles.spaced, styles.navigationText)}>
            {getCopy('detailPageNavigation.next', microcopy)}
          </Text>
          <Icon name="chevron-right" size={'2x'} />
        </Link>
      ) : (
        <span></span>
      )}
    </div>
  );
};

DetailNavigation.propTypes = {
  navigationObject: pt.object,
  type: pt.oneOf(['profile', 'project']),
};

DetailNavigation.defaultProps = {
  navigationObject: {},
  type: 'project',
};

export default DetailNavigation;
